<script setup lang="ts">
import type { ButtonVariant } from '@global-types/buttonVariant';

defineProps<{ variant?: ButtonVariant }>();
</script>

<template>
  <button
    class="btn"
    :class="variant ? `btn--${variant}` : ''"
  >
    <slot />
  </button>
</template>
